import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://www.pickuprentaltruckdubai.com';

const CanonicalURL: React.FC = () => {
  const location = useLocation();
  const canonicalUrl = location.pathname === '/' ? `${BASE_URL}/` : `${BASE_URL}${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalURL;
